import { Activity, Target, Voicemail } from 'react-feather'
import CompanyIcon from 'assets/images/company.svg'
import { object, string } from 'yup'

export const validationSchema = object().shape({
  tone: string(),
  description: string(),
  usp: string(),
  target_audience: string(),
})

export const checkEmptyResponse = (
  prefillData: Partial<Prefillbiodata>
): boolean => {
  const keys = Object.keys(prefillData) as Array<keyof typeof prefillData>
  if (keys.length === 0) return true

  let result = false
  keys.forEach(key => {
    if (!prefillData[key]) result = true
  })
  return result
}

export const fields = [
  {
    type: 'textarea',
    name: 'company_bio',
    label: (
      <span>
        {' '}
        <img src={CompanyIcon} alt="Company" /> Company Bio{' '}
      </span>
    ),
    required: false,
    fieldProps: { placeholder: 'Enter Companies Description', rows: 3 },
  },
  {
    type: 'textarea',
    name: 'usp',
    label: (
      <span>
        {' '}
        <Activity size={12} />
        Core Value Proposition{' '}
      </span>
    ),
    required: false,
    fieldProps: { placeholder: 'Whats unique about you ?', rows: 4 },
  },
  {
    type: 'textarea',
    name: 'target_audience',
    label: (
      <span>
        {' '}
        <Target size={12} /> Target Audience{' '}
      </span>
    ),
    required: false,
    fieldProps: { placeholder: 'Whom do you cater to ?', rows: 3 },
  },
  {
    type: 'textarea',
    name: 'tone',
    label: (
      <span>
        {' '}
        <Voicemail size={12} /> Brand Voice{' '}
      </span>
    ),
    required: false,
    fieldProps: { placeholder: 'What kind of Brand you are ?', rows: 3 },
  },
]
